import React, { Component } from 'react';
import { Formik, Form } from 'formik';

import queryString from "query-string";


import DatePickerField from "../forms/DatePickerField";

import AccountTimesheetDisplay from "./widgets/AccountTimesheetData"

import { LogTimesheetsApi } from "../../util/api/ServiceObjects/LogTimesheetsApi";

import { Alert } from "../../store/Alert";

import { observer } from 'mobx-react';

class KronosReport extends Component {
    static displayName = KronosReport.name;

    constructor(props) {
        super(props);

        props.store.getFromApi(["timesheets"])

        let params = queryString.parse(props.location.search)

        this.state = {
            loading: true,
            startDate: this.getStartDate(), 
            endDate: this.getNextFriday(new Date()),

            timsheetLogKey: "timesheet_" + Math.floor(Math.random() * Number.MAX_SAFE_INTEGER),

            certificationFilter: params.certificationFilter ? params.certificationFilter : "Not Logged"
        };

        this.props.store.updateBanner("Kronos Report");

        this.updateCertificationFilter = this.updateCertificationFilter.bind(this);

        this.updateStartDate = this.updateStartDate.bind(this);
        this.updateEndDate = this.updateEndDate.bind(this);

        this.filterAccountsByDate = this.filterAccountsByDate.bind(this);

        this.displayLogCheckbox = this.displayLogCheckbox.bind(this);
        this.toggleTimesheetLog = this.toggleTimesheetLog.bind(this);
        this.saveLoggedTimesheets = this.saveLoggedTimesheets.bind(this);
    }

    updateStartDate(date) {
        this.setState({ startDate: date });

        let windowStorage = window.localStorage;
        windowStorage.setItem("SWS_chronosStartDate", date);
    }

    updateEndDate(date) {
        console.log(date)
        this.setState({ endDate: date })
    }

    updateCertificationFilter(event) {
        this.setState({
            certificationFilter : event.target.value,
        });
    }


    getStartDate(date) {
        let windowStorage = window.localStorage;
        let startDate = windowStorage.getItem("SWS_chronosStartDate")

        if (startDate != null && startDate != "null") {
            return new Date(startDate);
        }
        else {
            var resultDate = new Date();
    
            resultDate.setMonth(resultDate.getMonth() - 3);
        
            return resultDate;    
        }
    }

    getNextFriday(date) {    
        var resultDate = new Date();
    
        resultDate.setDate(date.getDate() + (7 + 5 - date.getDay()) % 7);
    
        return resultDate;
    }


    displayFilters() {

        return (
            <React.Fragment>
            <div className="row">
                <div className="col-12 col-md-6 d-flex flex-column">
                        <h3 className="h5 mb-2 d-block">Include in search:</h3>
                        
                        <select className="form-control" 
                            name="certificationFilter" 
                            value={this.state.certificationFilter} 
                            onChange={this.updateCertificationFilter}
                        >
                            <option value="All">All</option>
                            <option value="Not Logged">Not Logged</option>
                            <option value="Logged">Logged</option>
                        </select>
                </div>
                <div className="col-12 col-md-6">
                    <h3 className="h5 d-block">Filter by <span style={{color: "#A41E35"}}>Certification Date:</span></h3>

                    <Formik
                        onSubmit={(values) => true }
                        initialValues={{ startDate: this.state.startDate, endDate: this.state.endDate }}
                        validate={values => {}}
                    >
                        <Form>

                            <DatePickerField 
                                name="startDate" 
                                onChange={this.updateStartDate} 
                                label="Start Date" 
                            />
                            
                            <DatePickerField name="endDate" 
                                onChange={this.updateEndDate} 
                                label="End Date"
                            />
                        </Form>
                    </Formik>
                </div>
            </div>
            <div className="row mt-3">
                <div className="ml-auto">
                    <button className="btn btn-primary" onClick={() => window.print()}>Print This Page</button>
                    <button className="btn btn-secondary ml-2" onClick={this.saveLoggedTimesheets}>Mark Reports as Logged</button>
                </div>
            </div>
            </React.Fragment>
        );
    }



    render() {
        return (
            <div>
                {this.displayFilters()}
                <div className="row">
                    {this.displayTimesheets()}
                </div>
            </div>
        )
    }


    filterAccountsByDate(accounts) {

        const filtered_accounts = accounts.map(account => {
            account = account.include(["student", "timestamp", "timesheet"]);

            let timesheets = account.timesheets;

            if (timesheets && timesheets.length > 0) {
                timesheets = timesheets.filter((timesheet) => {

                        //Make sure timesheet EXISTS
                        if (timesheet != null) {
                            //Ensure it is submitted - we don't show unsubmitted timesheets to admins
                            //We also only want to show certified timesheets on this page.
                            if (timesheet.isFinal == false || timesheet.isCertified == false) {
                                return false;
                            }

                            //If we have a cert or uncertified filter disabled
                            if (this.state.certificationFilter === "Not Logged") {
                                if(timesheet.isLogged) {
                                    return false;
                                }
                            }
                            //If we have a cert or uncertified filter disabled
                            if (this.state.certificationFilter === "Logged") {
                                if(!timesheet.isLogged) {
                                    return false;
                                }
                            }

                            let passesStartDate = true;
                            if (this.state.startDate) {
                                passesStartDate = new Date(timesheet.dateCertified) >= new Date(this.state.startDate)
                            }

                            let passesEndDate = true;
                            if (this.state.endDate){
                                passesEndDate = new Date(timesheet.dateSubmitted) <= new Date(this.state.endDate)
                            };

                            return (passesStartDate && passesEndDate);
                        }
                    });
                account.timesheets = timesheets;
            }
            else {
                account.timesheets = []
            }
            return account;
        });

        return filtered_accounts;
    }

    async saveLoggedTimesheets() {
        let retval = {
            "activate" : [],
            "toggle" : []
        }

        let timesheetIdsToUpdate = [];

        let accounts = this.props.store.accounts.collection;

        accounts = this.filterAccountsByDate(accounts);


        for(let i = 0; i < accounts.length; i++) {
            let account = accounts[i];

            if (account.timesheets.length > 0) {
                account.timesheets.map(timesheet => timesheetIdsToUpdate.push(timesheet.id))
            }
        }
        
        retval["activate"] = timesheetIdsToUpdate;


        try {
            let response = await LogTimesheetsApi.update(retval);

            await this.props.store.getFromApi();

            let successAlert = new Alert("Successfully saved", "Successfully logged timesheets to Kronos.", "sucess");
            this.props.store.addAlert(successAlert);

            const key = "timesheet_" + Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
            this.setState({timsheetLogKey : key})
        }
        catch (error) {
            if(error.response) {
                let alert = new Alert("An error occurred", error.response.data.title);
                this.props.store.addAlert(alert);
            }
            else {
                let alert = new Alert("Network Error", error.message);
                this.props.store.addAlert(alert);
            }
        }
    }


    async toggleTimesheetLog(event) {

        let timesheetId = event.target.value;
        let timesheet = this.props.store.timesheets.getById(timesheetId);

        //mutate timesheet
        timesheet.isLogged = !timesheet.isLogged;

        //save to api
        let response = await timesheet.save(this.props.store);

        console.log(response)
        if (response && response.errors) {
            timesheet.isLogged = !timesheet.isLogged;
        }

        const key = "timesheet_" + Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);

        await this.setState({timsheetLogKey : key})
    }

    displayLogCheckbox(timesheetId) {

        let timesheet = this.props.store.timesheets.getById(timesheetId)
        
        if (!timesheet.isLogged) {
            return (
                <button key={this.state.timsheetLogKey + "_" + timesheet.id} className="btn btn-light" value={timesheetId.toString()} type="button" onClick={this.toggleTimesheetLog}>
                    Log To Kronos
                </button>
            )
        }
        return (
            <button key={this.state.timsheetLogKey + "_" + timesheet.id} className="btn btn-secondary" value={timesheetId.toString()} type="button" onClick={this.toggleTimesheetLog}>
                Unlog To Kronos
            </button>
        )
    }


    
    displayTimesheets() {

        let accounts = this.props.store.accounts.collection;

        accounts = this.filterAccountsByDate(accounts)

        accounts = accounts.filter(account => account.timesheets.length > 0)


        let tableOptions = {
            showEdit : false,
            showLoggedToggle : true,
            showCertify : false,
            showStudentName : true,
            showEmployerName : true,
            showFopal : true,
            showTotalHours : true,
            showCertifiedDate : true,
            showWeekEndDate : true,
            showTimestampRange : true,
            showWeekPay : true,
            showBalance : true,
        }


        if (accounts.length > 0) {
            return (
                <AccountTimesheetDisplay
                    options={tableOptions}
                    accountIds={accounts.map(account => account.id)}
                    store={this.props.store}

                    tableProps={{ style: "mt-4" }}
                    headerGroupProps={{}}
                    rowProps={{}}
                    displayLogCheckbox={this.displayLogCheckbox}

                    key={this.state.timsheetLogKey}
                />
            );
        }
        else {
            return(
                <div>
                    <h2 className="h4 mt-4">Could not find any timesheets matching the filter parameters.</h2>
                </div>
            )
        }
    }
}

KronosReport = observer(KronosReport)

export {KronosReport};